/**
 * Quick-reply chips keep their visible size. On touch devices only (`pointer: coarse`) the invisible
 * `::after` grows to max(100%, 44px) around the chip, and the gap between stacked chips grows
 * (`CHIP_TOUCH_GAP_*`) so neighbouring touch targets touch but never overlap. A mouse sees no change.
 */
export const CHIP_HIT_AREA =
  "relative after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:content-[''] pointer-coarse:after:h-[max(100%,44px)] pointer-coarse:after:w-[max(100%,44px)]";

/** Gap that keeps 44px targets from overlapping: 24px thread chips + 20 = 44; 36px card chips + 8 = 44. */
export const CHIP_TOUCH_GAP_THREAD = "pointer-coarse:gap-5";
export const CHIP_TOUCH_GAP_CARD = "pointer-coarse:gap-2";

const CLAMP = "line-clamp-2 min-w-0 break-words";

/** A long label wraps to at most two lines, then an ellipsis (the full text stays the accessible name). */
export const CHIP_LABEL_CLAMP = `${CLAMP} text-start`;
/** In the launcher card the label aligns to the LAUNCHER side (physical), whatever the text direction. */
export const chipLabelClampOnSide = (onLeft: boolean) =>
  `${CLAMP} ${onLeft ? "text-left" : "text-right"}`;
